import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { ScriptLoaderModule } from '../script-loader/script-loader.module';

import { WishlistSaveButtonComponent } from './wishlist-save-button.component';

@NgModule({
  imports: [CommonModule, ScriptLoaderModule, WishlistSaveButtonComponent],
  exports: [WishlistSaveButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WishlistSaveButtonModule {}
